import { render, staticRenderFns } from "./MailingTemplateEditor.vue?vue&type=template&id=1213c431&scoped=true&"
import script from "./MailingTemplateEditor.vue?vue&type=script&lang=js&"
export * from "./MailingTemplateEditor.vue?vue&type=script&lang=js&"
import style0 from "./MailingTemplateEditor.vue?vue&type=style&index=0&id=1213c431&prod&lang=scss&"
import style1 from "./MailingTemplateEditor.vue?vue&type=style&index=1&id=1213c431&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1213c431",
  null
  
)

export default component.exports